import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from './app.state';

export const selectAppFeature = createFeatureSelector<AppState>('app');

export const selectActiveDialogs = createSelector(selectAppFeature, (state: AppState) => state.activeDialogs);

export const selectNotification = createSelector(selectAppFeature, (state: AppState) => state.notification);

export const appQuery = {
    selectAppFeature,
    selectNotification,
};
